export default __webpack_public_path__ + "static/media/select_arrow.4e16e5b1.svg";